import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useContext, useState} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {AutoComplete} from "../../shopdrawing/openings/AutoComplete";
import {Opening} from "../../../../api/Openings";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {useAlternative} from "../alternative/Alternative";
import {useProjectId} from "../../shopdrawing/ProjectName";

export function MoveSelectedOpenings(props: {
    ids: number[];
    onCancel: () => void;
    onDone: () => void;
}) {

    const alt = useAlternative();
    const project = useProjectId();
    const edit = useContext(EditContext);
    const reloadRef = useSyncedRef(edit.reload);

    const submit = useAsyncAction(async (input) => {
        await api.quoteOpenings.reSequence(input)
        reloadRef.current();
        props.onDone();
    }, []);

    const [value, setValue] = useState<QuoteOpening|null>(null);

    const onSubmit = () => {
        if(!value) return;
        submit.callback({
            project: project,
            alternative: alt,
            idOrder: makeIdOrder({
                selected: props.ids,
                startingSeqNumber: value?.seqNumber || 0,
                all: edit.dataRef.current.flatMap(v => v.rows),
            }),
        });
    };

    return (
        <Dialog2 open onClose={() => props.onCancel()} onEnterPress={onSubmit}>
            <DialogTitle>
                Move Selected Openings
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />

                <AutoComplete<QuoteOpening>
                    label="Select new starting sequence number"
                    search={async (s) => {
                        const list = edit.dataRef.current.flatMap(d => d.rows) as QuoteOpening[];

                        return list.filter(v => {
                            // if(v.name.toLowerCase().includes(s.toLowerCase())) return true;
                            if(v.seqNumber.toString().startsWith(s.toLowerCase())) return true;
                            return false;
                        });
                    }}
                    value={value}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={v => {
                        return v.seqNumber.toString()
                    }}
                    onSelect={setValue}
                />

            </DialogContent>
            <SmoothActionBar
                loading={submit.loading}
                error={submit.error}
                actionName="Update"
                submitDisabled={!value}
                onCancel={() => props.onCancel()}
                onSubmit={onSubmit}
            />
        </Dialog2>
    )
}

export function makeIdOrder(props: {
    selected: number[];
    startingSeqNumber: number;
    all: (Opening | QuoteOpening)[];
}) {

    props.selected.sort((a, b) => {
        const aItem = props.all.find(f => f.id === a);
        const bItem = props.all.find(f => f.id === b);

        return (aItem?.seqNumber || 0) - (bItem?.seqNumber || 0);
    })

    // console.log("makeIdOrder")
    // props.selected.map(id => {
    //     const item = props.all.find(f => f.id === id);
    //     console.log(item?.seqNumber);
    // });

    props.all.sort((a, b) => a.seqNumber - b.seqNumber);

    const before = props.all
        .filter(v => v.seqNumber < props.startingSeqNumber && !props.selected.includes(v.id))
        .map(v => v.id);
    const after = props.all
        .filter(v => v.seqNumber >= props.startingSeqNumber && !props.selected.includes(v.id))
        .map(v => v.id);

    return [
        ...before,
        ...props.selected,
        ...after,
    ]
}